import { ExpectedOrderTime, Merchant, Mission, Order } from '@m4a3/api-client';
import {
  API_DATA_REQUESTED,
  ORDER_RECEIVED,
  LANDING_ZONES_RECEIVED,
  ORDERS_RECEIVED,
  MISSION_RECEIVED,
  MISSIONS_RECEIVED,
  ORDER_TRACKING_RECEIVED,
  MERGED_ORDERS_RECEIVED,
  ORDER_ACCEPTED_REQUEST,
  ORDER_ACCEPTED_FAILURE,
  ORDER_ACCEPTED_SUCCESS,
  ORDER_REJECTED_REQUEST,
  ORDER_REJECTED_FAILURE,
  ORDER_REJECTED_SUCCESS,
  ORDER_REFUNDED_REQUEST,
  ORDER_REFUNDED_FAILURE,
  ORDER_REFUNDED_SUCCESS,
  CLEAR_SELECTED_ORDER,
  ORDERS_LOADING,
  SET_SELECTED_ORDER,
  SET_ORDER_STATUS_FILTER,
  SET_ORDER_WITHIN_TIME_FILTER,
  GET_STORES_ORDER_CAPACITY,
  JE_ORDER_ACCEPTED_FAILURE,
  JE_ORDER_ACCEPTED_SUCCESS,
  JE_ORDER_ACCEPTED_REQUEST,
  GET_ADMIN_SETTINGS_REQUEST,
  GET_ADMIN_SETTINGS_FAILURE,
  GET_ADMIN_SETTINGS_SUCCESS,
  GET_CELL_COMMERCIAL_CONFIG_REQUESTED,
  GET_CELL_COMMERCIAL_CONFIG_SUCCESSFUL,
  GET_CELL_COMMERCIAL_CONFIG_FAILED,
  SET_OPEN_STORE_SUCCESS,
  SET_AUTO_ACCEPT_SUCCESS,
  ALL_ORDERS_FOR_TODAY_TOMORROW_REQUEST,
  GET_CELLS_SUCCESS,
  GET_CELLS_FAILURE,
  SET_SELECTED_CELL,
  UPDATE_TAGS_PENDING,
  UPDATE_TAGS_FULFILLED,
  UPDATE_TAGS_FAILED,
  SET_REFRESH_INTERVAL,
  RESEND_ORDER_REQUEST,
  RESEND_ORDER_FAILURE,
  RESEND_ORDER_SUCCESS,
  ALL_ORDERS_FOR_TODAY_TOMORROW_SUCCESS,
  ALL_ORDERS_FOR_TODAY_TOMORROW_FAILURE,
  UPDATE_DEPARTURE_PAD_PENDING,
  UPDATE_DEPARTURE_PAD_FULFILLED,
  UPDATE_DEPARTURE_PAD_FAILED,
  SET_ROUTE_CONFIRMATION_ORDER,
  SET_LANE,
  ACTIVATE_JUST_EAT_FULFILLED,
  GET_JUST_EAT_ACTIVE_FULFILLED,
  DEACTIVATE_JUST_EAT_FULFILLED,
  SET_INVALIDATING_AN_ORDERS_DROP_LOCATION,
  SET_HOVER_DEPARTURE_PAD,
  SET_HOVER_ARRIVAL_PAD,
  ORDER_STATUS_UPDATED,
  SET_HOVER_AIRCRAFT,
  SET_HOVER_ORDER,
  SET_HOVER_TEAM,
  UPDATE_ARRIVAL_PAD_FULFILLED,
  SET_USE_SSE_FOR_ORDERS,
  SET_SHOW_COMPLETED_CANCELLED_ORDERS,
  GET_ORDER_HISTORY_REQUEST,
  GET_ORDER_HISTORY_SUCCESS,
  GET_ORDER_HISTORY_FAILURE,
  GET_LATEST_EXPECTED_ORDER_TIME_REQUEST,
  GET_LATEST_EXPECTED_ORDER_TIME_SUCCESS,
  GET_LATEST_EXPECTED_ORDER_TIME_FAILURE,
  GET_MERCHANTS_IN_CELL_REQUEST,
  GET_MERCHANTS_IN_CELL_SUCCESS,
  GET_MERCHANTS_IN_CELL_FAILURE,
} from 'actions/actionTypes';
import { AnyAction } from 'redux';
import { persistReducer } from 'redux-persist';
import { v4 as uuid } from 'uuid';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { CellCommercialConfig } from '@m4a3/api-client/dist/models/cell-commercial-config.interface';
import { findOverweightOrderPairings } from '../utils/orderUtils';

export type Slot = {
  id: number;
  startTime: number;
  durationMinutes: number;
  slotHistories: { action: string }[];
  orders: Order[];
};
type OrdersState = {
  orderDetails: Order | null;
  ordersToFilter: Order[];
  createdOrders: Order[];
  mergedOrderIds: Order[];
  mergedOrders: Order[];
  orderIdsWithOverweightColorPairings: { [key: string]: { color: string, eircode: string, linkedOverweightOrderIds: string[] } };
  latestExpectedOrderTimeByOrderId: { [orderId: string]: ExpectedOrderTime | null | undefined };
  isFetchingLatestExpectedOrderTimeByOrderId: { [orderId: string]: boolean | undefined };
  missions: {
    list: Mission[];
  };
  selected: string;
  tracked: {
    order: {};
    mission: {};
    track: {};
  };
  acceptingOrderWithEta: boolean;
  loadingOrderCapacity: boolean;
  loading: boolean;
  updatingOrderCapacity: boolean;
  resettingOrderCapacity: boolean;
  rejecting: boolean;
  refunding: boolean;
  statusFilter: null | string;
  timeFilter: 120;
  aircraft: [];
  adminSettings: {};
  selectedCellId: number;
  cellCommercialConfig: CellCommercialConfig;
  isCellCommercialConfigLoading: boolean;
  cellCommercialConfigLoadingError: Error;
  refreshInterval: number;
  resending: boolean;
  hoverOrder: string | null;
  hoverTeam: string | null;
  hoverAircraft: string | null;
  hoverDeparturePad: string | null;
  hoverArrivalPad: string | null;
  allOrdersForTodayAndTomorrow: { [key in string]: Slot[] } | undefined;
  orderHistoryById: { [orderId: string]: any[] } | undefined;
  isFetchingOrderHistory: boolean;
  isFetchingUpdateAircraft: boolean;
  isFetchingUpdateDeparturePad: boolean;
  cells: any[] | undefined;
  merchants: Merchant[] | undefined;
  merchantsLoading: boolean;
  merchantsError: any | null;
  regions: string[] | undefined;
  routeConfirmationOrder: Order | null;
  lane: string;
  landingZones: [];
  justEatEnabled: boolean;
  invalidatingAnOrdersDropLocation: boolean;
  useSSEForOrders: boolean;
  showCompletedCancelledOrders: boolean;
};

const defaultState: OrdersState = {
  ordersToFilter: [],
  createdOrders: [],
  mergedOrderIds: [],
  mergedOrders: [],
  orderIdsWithOverweightColorPairings: {},
  latestExpectedOrderTimeByOrderId: {},
  isFetchingLatestExpectedOrderTimeByOrderId: {},
  missions: {
    list: []
  },
  selected: null,
  tracked: {
    order: {},
    mission: {},
    track: {}
  },
  acceptingOrderWithEta: false,
  loadingOrderCapacity: false,
  loading: false,
  updatingOrderCapacity: false,
  resettingOrderCapacity: false,
  rejecting: false,
  refunding: false,
  statusFilter: null,
  timeFilter: 120,
  aircraft: [],
  adminSettings: {},
  selectedCellId: 7,
  cellCommercialConfig: null,
  isCellCommercialConfigLoading: false,
  cellCommercialConfigLoadingError: null,
  refreshInterval: 30,
  resending: false,
  hoverOrder: null,
  hoverTeam: null,
  hoverAircraft: null,
  hoverDeparturePad: null,
  hoverArrivalPad: null,
  orderHistoryById: undefined,
  isFetchingOrderHistory: false,
  isFetchingUpdateAircraft: false,
  isFetchingUpdateDeparturePad: false,
  allOrdersForTodayAndTomorrow: undefined,
  cells: undefined,
  merchants: undefined,
  merchantsLoading: false,
  merchantsError: null,
  regions: undefined,
  routeConfirmationOrder: null,
  orderDetails: null,
  lane: '',
  landingZones: [],
  justEatEnabled: false,
  invalidatingAnOrdersDropLocation: false,
  useSSEForOrders: false,
  showCompletedCancelledOrders: false
};

const reducer = (state: OrdersState = defaultState, action: AnyAction) => {
  switch (action.type) {
    case API_DATA_REQUESTED:
      return {
        ...state
      };
    case SET_ORDER_STATUS_FILTER: {
      return {
        ...state,
        statusFilter: action.payload
      };
    }
    case SET_ORDER_WITHIN_TIME_FILTER: {
      return {
        ...state,
        timeFilter: action.payload
      };
    }
    case ORDERS_LOADING: {
      return {
        ...state,
        loading: action.payload
      };
    }
    case ORDERS_RECEIVED: {
      let updatedDetails: Order;
      if (state.orderDetails) {
        const newDetails = action.payload.ordersToFilter.find(order => {
          return order.id === state.orderDetails.id;
        });

        updatedDetails = {
          ...state.orderDetails,
          ...newDetails
        };
      }

      const orderIdsWithOverweightColorPairings = findOverweightOrderPairings({
        ordersToFilter: action.payload.ordersToFilter,
        existingColorPairings: state.orderIdsWithOverweightColorPairings
      });

      return {
        ...state,
        ordersToFilter: action.payload.ordersToFilter as Order[],
        orderIdsWithOverweightColorPairings: orderIdsWithOverweightColorPairings,
        createdOrders: action.payload.createdOrders,
        orderDetails: updatedDetails ? updatedDetails : state.orderDetails
      };
    }
    case LANDING_ZONES_RECEIVED:
      return {
        ...state,
        landingZones: action.payload
    };
    case MERGED_ORDERS_RECEIVED:
      return {
        ...state,
        selected: null
      };
    case ORDER_RECEIVED: {
      let newRouteConfirmationOrder: Order
      if (action.payload?.id === state.routeConfirmationOrder?.id) {
        newRouteConfirmationOrder = action.payload;
      }

      return {
        ...state,
        orderDetails: action.payload,
        routeConfirmationOrder: newRouteConfirmationOrder ? newRouteConfirmationOrder : state.routeConfirmationOrder,
      };
    }
    case ORDER_TRACKING_RECEIVED:
      return {
        ...state,
        tracked: {
          ...action.payload
        }
      };
    case CLEAR_SELECTED_ORDER: {
      return {
        ...state,
        selected: null,
        orderDetails: null
      };
    }
    case SET_SELECTED_ORDER: {
      if (
        action.payload === state.orderDetails?.id ||
        action.payload === state.selected
      )
        return state;
      return {
        ...state,
        selected: action.payload,
        orderDetails: null
      };
    }
    case ORDER_ACCEPTED_REQUEST: {
      return {
        ...state,
        acceptingOrderWithEta: action.payload
      };
    }
    case ORDER_ACCEPTED_SUCCESS: {
      return {
        ...state,
        acceptingOrderWithEta: false
      };
    }
    case ORDER_ACCEPTED_FAILURE: {
      return {
        ...state,
        acceptingOrderWithEta: false
      };
    }
    case JE_ORDER_ACCEPTED_REQUEST: {
      return {
        ...state,
        acceptingJEOrder: true
      };
    }
    case JE_ORDER_ACCEPTED_SUCCESS: {
      return {
        ...state,
        acceptingJEOrder: false
      };
    }
    case JE_ORDER_ACCEPTED_FAILURE: {
      return {
        ...state,
        acceptingJEOrder: false
      };
    }
    case ORDER_REJECTED_REQUEST: {
      return {
        ...state,
        rejecting: true
      };
    }
    case ORDER_REJECTED_SUCCESS: {
      return {
        ...state,
        rejecting: false,
        selected: {}
      };
    }
    case ORDER_REJECTED_FAILURE: {
      return {
        ...state,
        rejecting: false
      };
    }
    case ORDER_REFUNDED_REQUEST: {
      return {
        ...state,
        refunding: true
      };
    }
    case ORDER_REFUNDED_SUCCESS: {
      return {
        ...state,
        refunding: false,
      };
    }
    case ORDER_REFUNDED_FAILURE: {
      return {
        ...state,
        refunding: false
      };
    }
    case RESEND_ORDER_REQUEST: {
      return {
        ...state,
        resending: true
      };
    }
    case RESEND_ORDER_FAILURE: {
      return {
        ...state,
        resending: false
      };
    }
    case RESEND_ORDER_SUCCESS: {
      return {
        ...state,
        resending: false
      };
    }
    case MISSIONS_RECEIVED:
      return {
        ...state,
        missions: { ...state.missions, list: action.payload }
      };
    case MISSION_RECEIVED:
      return {
        ...state,
        orderDetails: { ...state.orderDetails, mission: action.payload }
      };
    case GET_STORES_ORDER_CAPACITY:
      return {
        ...state,
        storesOrderCapacity: action.payload,
        loadingOrderCapacity: false,
        updatingOrderCapacity: false
      };
    case GET_ADMIN_SETTINGS_REQUEST:
      return {
        ...state,
        fetchingAdminSettings: true
      };
    case GET_ADMIN_SETTINGS_FAILURE:
      return {
        ...state,
        fetchingAdminSettings: false,
        adminSettings: false
      };
    case GET_ADMIN_SETTINGS_SUCCESS: {
      return {
        ...state,
        fetchingAdminSettings: false,
        adminSettings: {
          ...state.adminSettings,
          storeopen: action.payload.storeopen,
          autoaccepton: action.payload.autoaccepton
        }
      };
    }
    case GET_CELL_COMMERCIAL_CONFIG_REQUESTED:
      return {
        ...state,
        isCellCommercialConfigLoading: true,
        cellCommercialConfig: null,
        cellCommercialConfigLoadingError: null,
      };
    case GET_CELL_COMMERCIAL_CONFIG_SUCCESSFUL:
      return {
        ...state,
        isCellCommercialConfigLoading: false,
        cellCommercialConfig: action.payload,
        cellCommercialConfigLoadingError: null,
      };
    case GET_CELL_COMMERCIAL_CONFIG_FAILED:
      return {
        ...state,
        isCellCommercialConfigLoading: false,
        cellCommercialConfig: null,
        cellCommercialConfigLoadingError: action.payload
      };
    case SET_OPEN_STORE_SUCCESS:
      return {
        ...state,
        adminSettings: {
          ...state.adminSettings,
          storeopen: action.payload
        }
      };
    case SET_AUTO_ACCEPT_SUCCESS:
      return {
        ...state,
        adminSettings: {
          ...state.adminSettings,
          autoaccepton: action.payload
        }
      };
    case ALL_ORDERS_FOR_TODAY_TOMORROW_REQUEST:
      return {
        ...state,
        loadingTimetable: true
      };
    case ALL_ORDERS_FOR_TODAY_TOMORROW_SUCCESS:
      return {
        ...state,
        allOrdersForTodayAndTomorrow: action.payload as {
          [key in string]: Slot[];
        },
        loadingTimetable: false
      };
    case ALL_ORDERS_FOR_TODAY_TOMORROW_FAILURE:
      return {
        ...state,
        loadingTimetable: false
      };
    case GET_ORDER_HISTORY_REQUEST: {
      return {
        ...state,
        isFetchingOrderHistory: true
      };
    }
    case GET_ORDER_HISTORY_SUCCESS: {
      const { orderId, history } = action.payload || {};
      return {
        ...state,
        isFetchingOrderHistory: false,
        orderHistoryById: {
          ...(state.orderHistoryById || {}),
          [orderId]: history || []
        }
      };
    }
    case GET_ORDER_HISTORY_FAILURE: {
      return {
        ...state,
        isFetchingOrderHistory: false
      };
    }
    case GET_LATEST_EXPECTED_ORDER_TIME_REQUEST: {
      const { orderId } = action.payload || {};
      if (!orderId) return state;
      return {
        ...state,
        isFetchingLatestExpectedOrderTimeByOrderId: {
          ...state.isFetchingLatestExpectedOrderTimeByOrderId,
          [orderId]: true
        }
      };
    }
    case GET_LATEST_EXPECTED_ORDER_TIME_SUCCESS: {
      const { orderId, expectedOrderTime } = action.payload || {};
      if (!orderId) return state;
      return {
        ...state,
        isFetchingLatestExpectedOrderTimeByOrderId: {
          ...state.isFetchingLatestExpectedOrderTimeByOrderId,
          [orderId]: false
        },
        latestExpectedOrderTimeByOrderId: {
          ...state.latestExpectedOrderTimeByOrderId,
          [orderId]: expectedOrderTime
        }
      };
    }
    case GET_LATEST_EXPECTED_ORDER_TIME_FAILURE: {
      const { orderId } = action.payload || {};
      if (!orderId) return state;
      return {
        ...state,
        isFetchingLatestExpectedOrderTimeByOrderId: {
          ...state.isFetchingLatestExpectedOrderTimeByOrderId,
          [orderId]: false
        }
      };
    }
    case GET_CELLS_SUCCESS:
      return {
        ...state,
        cells: action.payload,
        cellError: null
      };
    case GET_CELLS_FAILURE:
      return {
        ...state,
        cellError: action.payload,
        cells: []
      };
    case SET_SELECTED_CELL:
      return {
        ...state,
        selectedCellId: action.payload
      };
    case GET_MERCHANTS_IN_CELL_REQUEST:
      return {
        ...state,
        merchantsLoading: true,
        merchantsError: null
      };
    case GET_MERCHANTS_IN_CELL_SUCCESS:
      return {
        ...state,
        merchants: action.payload,
        merchantsLoading: false,
        merchantsError: null
      };
    case GET_MERCHANTS_IN_CELL_FAILURE:
      return {
        ...state,
        merchantsLoading: false,
        merchantsError: action.payload,
        merchants: []
      };
    case UPDATE_TAGS_PENDING: {
      return {
        ...state
      };
    }
    case UPDATE_TAGS_FULFILLED: {
      const orderId = action.payload.id;
      const newOrders = state.ordersToFilter?.map(order => {
        if (order?.id === orderId) {
          return { ...order, tags: action.payload?.tags || [] };
        } else {
          return order;
        }
      });
      return {
        ...state,
        ordersToFilter: newOrders as Order[]
      };
    }
    case UPDATE_TAGS_FAILED: {
      return {
        ...state
      };
    }
    case SET_REFRESH_INTERVAL:
      return {
        ...state,
        refreshInterval: action.payload
      };
    case UPDATE_DEPARTURE_PAD_PENDING: {
      return { ...state, isFetchingUpdateDeparturePad: action.payload };
    }
    case UPDATE_DEPARTURE_PAD_FULFILLED: {
      const { id, departurePad } = action.payload;
      return {
        ...state,
        ordersToFilter: state.ordersToFilter.map(order => {
          if (order.id === id) {
            return {
              ...order,
              originLandingPadId: departurePad 
            };
          }
          return order;
        }) as Order[], 
        orderDetails: state.orderDetails?.id === id 
          ? { ...state.orderDetails, departurePad, originLandingPadId: departurePad } 
          : state.orderDetails
      };
    }
    case UPDATE_DEPARTURE_PAD_FAILED: {
      return { ...state, isFetchingUpdateDeparturePad: false };
    }
    case ORDER_STATUS_UPDATED: {
      const orderId = action.payload.orderId;
      const newOrders = state.ordersToFilter?.map(order => {
        if (order?.id === orderId) {
          return { ...order, status: action.payload.status };
        } else {
          return order;
        }
      });
      return {
        ...state,
        ordersToFilter: newOrders as Order[],
        orderDetails: {
          ...state.orderDetails,
          status: action.payload.status
        }
      };
    }
    case SET_HOVER_ORDER: {
      return {
        ...state,
        hoverOrder: action.payload
      };
    }
    case SET_HOVER_TEAM: {
      return {
        ...state,
        hoverTeam: action.payload
      };
    }
    case SET_HOVER_AIRCRAFT: {
      return {
        ...state,
        hoverAircraft: action.payload
      };
    }
    case SET_HOVER_DEPARTURE_PAD: {
      return {
        ...state,
        hoverDeparturePad: action.payload
      };
    }
    case SET_HOVER_ARRIVAL_PAD: {
      return {
        ...state,
        hoverArrivalPad: action.payload
      };
    }
    case SET_ROUTE_CONFIRMATION_ORDER: {
      return {
        ...state,
        routeConfirmationOrder: action.payload
      };
    }
    case SET_LANE: {
      return {
        ...state,
        lane: action.payload
      };
    }
    case GET_JUST_EAT_ACTIVE_FULFILLED: {
      return {
        ...state,
        justEatEnabled: action.payload
      };
    }
    case DEACTIVATE_JUST_EAT_FULFILLED: {
      return {
        ...state,
        justEatEnabled: action.payload
      };
    }
    case ACTIVATE_JUST_EAT_FULFILLED: {
      return {
        ...state,
        justEatEnabled: action.payload
      };
    }
    case SET_INVALIDATING_AN_ORDERS_DROP_LOCATION: {
      return {
        ...state,
        invalidatingAnOrdersDropLocation: action.payload
      };
    }
    case UPDATE_ARRIVAL_PAD_FULFILLED: {
      const { id, arrivalPad } = action.payload;
      return {
        ...state,
        ordersToFilter: state.ordersToFilter.map(order => {
          if (order.id === id) {
            return {
              ...order,
              arrivalPad
            };
          }
          return order;
        }) as Order[],
        orderDetails: state.orderDetails?.id === id 
          ? { ...state.orderDetails, arrivalPad } 
          : state.orderDetails
      };
    }
    case 'ORDER_CARD_UPSERTED': {
      const card = action.payload as any;
      const existingIdx = state.ordersToFilter.findIndex(o => o?.id === card?.id);
      let updatedOrders: Order[];
      if (existingIdx >= 0) {
        updatedOrders = state.ordersToFilter.map((o, idx) => {
          if (idx === existingIdx) {
            return { ...o, ...card } as any;
          }
          return o;
        }) as Order[];
      } else {
        updatedOrders = [card as any, ...state.ordersToFilter] as Order[];
      }
      const updatedOrderDetails = state.orderDetails?.id === card?.id
        ? { ...state.orderDetails, ...card } as any
        : state.orderDetails;
      return {
        ...state,
        ordersToFilter: updatedOrders,
        orderDetails: updatedOrderDetails
      };
    }
    case 'UPDATE_LANDING_ZONE_LOCALLY': {
      const { id, landingZoneId, landingZoneName } = action.payload;
      return {
        ...state,
        ordersToFilter: state.ordersToFilter.map(order => {
          if (order.id === id) {
            return {
              ...order,
              landingZoneId,
              landingZoneName: landingZoneName ?? order.landingZoneName
            };
          }
          return order;
        }) as Order[],
        orderDetails: state.orderDetails?.id === id
          ? { ...state.orderDetails, landingZoneId, landingZoneName: landingZoneName ?? state.orderDetails.landingZoneName }
          : state.orderDetails
      };
    }
    case SET_USE_SSE_FOR_ORDERS: {
      return {
        ...state,
        useSSEForOrders: action.payload
      };
    }
    case SET_SHOW_COMPLETED_CANCELLED_ORDERS: {
      return {
        ...state,
        showCompletedCancelledOrders: action.payload
      };
    }
    default:
      return state;
  }
};

const persistConfig = {
  key: 'order',
  storage,
  whitelist: ['refreshInterval', 'timeFilter', 'selectedCellId', 'lane']
};
export default persistReducer(persistConfig, reducer);
